module.exports = __webpack_public_path__ + "img/logo1.e9b03807.png";